import React from 'react';
import { useCurrency } from '../../../../hooks/useCurrency';
import { InvoiceItem } from '../types';

interface ItemsTableProps {
  items: InvoiceItem[];
  variant?: 'standard' | 'compact' | 'minimal';
  headerColor?: string;
}

export default function ItemsTable({ items, variant = 'standard', headerColor = 'bg-primary-600' }: ItemsTableProps) {
  const { formatCurrency } = useCurrency();
  if (variant === 'minimal') {
    return (
      <div className="mb-4">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-gray-300">
              <th className="text-left py-2">Description</th>
              <th className="text-right py-2">Qty</th>
              <th className="text-right py-2">Price</th>
              <th className="text-right py-2">Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id} className="border-b border-gray-200">
                <td className="py-2">{item.description}</td>
                <td className="text-right py-2">{item.quantity}</td>
                <td className="text-right py-2">{formatCurrency(item.unit_price)}</td>
                <td className="text-right py-2">{formatCurrency(item.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  if (variant === 'compact') {
    return (
      <div className="mb-4">
        <table className="w-full text-xs">
          <thead>
            <tr className={`${headerColor} text-white`}>
              <th className="text-left py-1 px-2">Item</th>
              <th className="text-center py-1 px-2">Qty</th>
              <th className="text-right py-1 px-2">Rate</th>
              <th className="text-right py-1 px-2">Amount</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={item.id} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
                <td className="py-1 px-2">{item.description}</td>
                <td className="text-center py-1 px-2">{item.quantity}</td>
                <td className="text-right py-1 px-2">{formatCurrency(item.unit_price)}</td>
                <td className="text-right py-1 px-2">{formatCurrency(item.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="mb-6">
      <table className="w-full">
        <thead>
          <tr className={`${headerColor} text-white`}>
            <th className="text-left py-3 px-4">SL</th>
            <th className="text-left py-3 px-4">Description</th>
            <th className="text-center py-3 px-4">Quantity</th>
            <th className="text-right py-3 px-4">Unit Price</th>
            <th className="text-right py-3 px-4">Total</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => (
            <tr key={item.id} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
              <td className="py-2 px-4">{index + 1}</td>
              <td className="py-2 px-4">{item.description}</td>
              <td className="text-center py-2 px-4">{item.quantity}</td>
              <td className="text-right py-2 px-4">{formatCurrency(item.unit_price)}</td>
              <td className="text-right py-2 px-4">{formatCurrency(item.total)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
